import { useTranslation } from 'react-i18next';

import { Typography } from '@cfa/react-components';

const HeaderTitle: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="py-6 text-center md:py-12">
      <Typography data-testid="PageHeader" variant="h2">
        {t('Generic.admin')}
      </Typography>
    </div>
  );
};

export default HeaderTitle;
